import React from 'react'
import JobOverviewStep from '../../pages/recruiter/components/JobOverviewStep';
import DescriptionStep from '../../pages/recruiter/components/DescriptionStep';
import QualificationsStep from '../../pages/recruiter/components/QualificationsStep';
import ScreeningQuestionsStep from '../../pages/recruiter/components/ScreeningQuestionsStep';
import ApplicationDetailsStep from '../../pages/recruiter/components/ApplicationDetailsStep';
import ReviewStep from '../../pages/recruiter/components/ReviewStep';
import useFieldChoices from '../../hooks/useFieldChoices';

const RenderStepContent = ({activeStep, formData, handleChange, errors,jobId, jobPostingChoices}) => {
  // pilot_type_choices
  const {fieldChoices} = useFieldChoices()
      switch (activeStep) {
      case 0:
        return (
          <JobOverviewStep
            data={formData}
            onChange={handleChange}
            errors={errors}
            dropDownOptions={{
              jobTypeChoices: jobPostingChoices?.job_type_choices,
              preferredCandidateNationalitiesChoices: jobPostingChoices?.preferred_candidate_nationalities_choices,
              pilotTypeChoices: fieldChoices?.pilot_type_choices,
              aviationCategoryChoices: fieldChoices?.aviation_category_choices
            }}
          />
        );
      case 1:
        return (
          <DescriptionStep
            data={formData}
            onChange={handleChange}
            errors={errors}
            dropDownOptions={{
              qualificationChoices: jobPostingChoices?.qualification_choices
            }}
          />
        );
      case 2:
        return (
          <QualificationsStep
            data={formData}
            onChange={handleChange}
            errors={errors}
            dropDownOptions={{
              experienceLevelChoices: jobPostingChoices?.experience_level_choices,
              aircraftTypeChoices: jobPostingChoices?.aircraft_type_choices || [],
              visaRequirementsChoices: jobPostingChoices?.visa_requirements_choices,
              medicalClassChoices: jobPostingChoices?.medical_class_choices,
            }}
          />
        );
      // case 3:
      //   return (
      //     <ScreeningQuestionsStep
      //       data={formData.screening_questions}
      //       onChange={handleChange}
      //       dropDownOptions={{
      //         screeningQuestionChoices: jobPostingChoices.screening_question_choices
      //       }}
      //     />
      //   );
      case 3:
        return (
          <ApplicationDetailsStep
            data={formData}
            onChange={handleChange}
            errors={errors}
            jobId={jobId}
            dropDownOptions={{
              visibilityChoices: jobPostingChoices?.visibility_choices,
              statusChoices: jobPostingChoices?.status_choices,
              interviewModeChoices: jobPostingChoices?.interview_mode_choices || [],
            }}
          />
        );
      default:
        return <ReviewStep data={formData} errors={errors} />;
    }
}

export default RenderStepContent